import {
  archivePlaybookTemplate,
  setInactivePlaybookTemplate,
  createPlaybookTemplate,
  editPlaybookTemplate,
  fetchAllPlaybookTemplates,
  fetchPlaybookTemplateById,
  showPlaybookTemplateAddEditForm,
  applyPlaybookTemplate,
  setActivePlaybookTemplate,
  fetchPlaybookTemplateChangelog,
  fetchPlaybookTaskTemplateChangelog,
} from '../../routines/playbookTemplateRoutines';

const initialState = {
  // template list
  playbookTemplateList: [],
  playbookTemplateListLoading: false,
  playbookTemplateListSuccess: false,

  // template by id
  selectedPlaybookTemplate: null,
  selectedPlaybookTemplateLoading: false,
  selectedPlaybookTemplateSuccess: false,

  // actions
  playbookTemplateArchiving: false,
  playbookTemplateSettingInactive: false,
  playbookTemplateApplying: false,

  // create/update
  playbookTemplateCreating: false,
  playbookTemplateCreateSuccess: false,
  playbookTemplateUpdating: false,
  playbookTemplateUpdateSuccess: false,

  // other
  showAddEditForm: false,
};

const playbookTemplateReducer = (state = initialState, action) => {
  switch (action.type) {
    case showPlaybookTemplateAddEditForm.TRIGGER:
      return {
        ...state,
        showAddEditForm: action.payload.showForm,
      };

    // fetch playbookTemplates
    case fetchAllPlaybookTemplates.TRIGGER:
      return {
        ...state,
        playbookTemplateListSuccess: false,
        playbookTemplateListLoading: true,
      };
    case fetchAllPlaybookTemplates.SUCCESS:
      return {
        ...state,
        playbookTemplateListLoading: false,
        playbookTemplateListSuccess: true,
        playbookTemplateList: action.payload?.data || [],
      };
    case fetchAllPlaybookTemplates.FAILURE:
      return {
        ...state,
        playbookTemplateListLoading: false,
        playbookTemplateListSuccess: false,
      };

    // fetch playbookTemplates by ID
    case fetchPlaybookTemplateById.TRIGGER:
      return {
        ...state,
        selectedPlaybookTemplateLoading: true,
      };
    case fetchPlaybookTemplateById.SUCCESS:
      return {
        ...state,
        selectedPlaybookTemplateLoading: false,
        selectedPlaybookTemplateSuccess: true,
        selectedPlaybookTemplate: action.payload?.data || null,
      };
    case fetchPlaybookTemplateById.FAILURE:
      return {
        ...state,
        selectedPlaybookTemplateLoading: false,
        selectedPlaybookTemplateSuccess: false,
      };

    // fetch changelog by playbookTemplateId
    case fetchPlaybookTemplateChangelog.TRIGGER:
      return {
        ...state,
        selectedPlaybookTemplate: {
          ...state.selectedPlaybookTemplate,
          changeLogLoading: true,
        },
      };
    case fetchPlaybookTemplateChangelog.SUCCESS:
      return {
        ...state,
        selectedPlaybookTemplate: {
          ...state.selectedPlaybookTemplate,
          changeLogLoading: false,
          changeLogSuccess: true,
          changeLog: action.payload?.data || [],
        },
      };
    case fetchPlaybookTemplateChangelog.FAILURE:
      return {
        ...state,
        selectedPlaybookTemplate: {
          ...state.selectedPlaybookTemplate,
          changeLogLoading: false,
          changeLogSuccess: false,
        },
      };

    // fetch changelog by playbookTaskTemplateId
    case fetchPlaybookTaskTemplateChangelog.TRIGGER:
      return {
        ...state,
        selectedPlaybookTaskTemplate: {
          ...state.selectedPlaybookTaskTemplate,
          changeLogLoading: true,
        },
      };
    case fetchPlaybookTaskTemplateChangelog.SUCCESS:
      return {
        ...state,
        selectedPlaybookTaskTemplate: {
          ...state.selectedPlaybookTaskTemplate,
          changeLogLoading: false,
          changeLogSuccess: true,
          changeLog: action.payload?.data || [],
        },
      };
    case fetchPlaybookTaskTemplateChangelog.FAILURE:
      return {
        ...state,
        selectedPlaybookTaskTemplate: {
          ...state.selectedPlaybookTaskTemplate,
          changeLogLoading: false,
          changeLogSuccess: false,
        },
      };

    // create playbookTemplates
    case createPlaybookTemplate.TRIGGER:
      return {
        ...state,
        playbookTemplateCreateSuccess: false,
        playbookTemplateCreating: true,
      };
    case createPlaybookTemplate.SUCCESS:
      return {
        ...state,
        playbookTemplateCreateSuccess: true,
        playbookTemplateCreating: false,
      };
    case createPlaybookTemplate.FAILURE:
      return {
        ...state,
        playbookTemplateCreateSuccess: false,
        playbookTemplateCreating: false,
      };

    // update playbookTemplates
    case editPlaybookTemplate.TRIGGER:
      return {
        ...state,
        playbookTemplateUpdateSuccess: false,
        playbookTemplateUpdating: true,
      };
    case editPlaybookTemplate.SUCCESS:
      return {
        ...state,
        playbookTemplateUpdateSuccess: true,
        playbookTemplateUpdating: false,
      };
    case editPlaybookTemplate.FAILURE:
      return {
        ...state,
        playbookTemplateUpdateSuccess: false,
        playbookTemplateUpdating: false,
      };

    // archive playbookTemplates
    case archivePlaybookTemplate.TRIGGER:
      return {
        ...state,
        playbookTemplateArchiving: true,
      };
    case archivePlaybookTemplate.SUCCESS:
    case archivePlaybookTemplate.FAILURE:
      return {
        ...state,
        playbookTemplateArchiving: false,
      };

    // set inactive playbookTemplates
    case setInactivePlaybookTemplate.TRIGGER:
      return {
        ...state,
        playbookTemplateSettingInactive: true,
      };
    case setInactivePlaybookTemplate.SUCCESS:
    case setInactivePlaybookTemplate.FAILURE:
      return {
        ...state,
        playbookTemplateSettingInactive: false,
      };

    // set active playbookTemplates
    case setActivePlaybookTemplate.TRIGGER:
      return {
        ...state,
        playbookTemplateSettingActive: true,
      };
    case setActivePlaybookTemplate.SUCCESS:
    case setActivePlaybookTemplate.FAILURE:
      return {
        ...state,
        playbookTemplateSettingActive: false,
      };

    // apply playbookTemplates
    case applyPlaybookTemplate.TRIGGER:
      return {
        ...state,
        playbookTemplateApplying: true,
      };
    case applyPlaybookTemplate.SUCCESS:
    case applyPlaybookTemplate.FAILURE:
      return {
        ...state,
        playbookTemplateApplying: false,
      };

    default:
      return state;
  }
};

export default playbookTemplateReducer;
